import { Component } from '@angular/core';

@Component({
    selector: 'responsibility',
    templateUrl: 'responsibility.component.html',
    styleUrls: ['./responsibility.component.scss']
})
export class ResponsibilityComponent {
    markers = [
        {
            title: 'Инновационные трамваи',
            anchor: 'innovation',
            icon: 'fa-wifi',
            description: 'сохранение общегородские тарифов и льгот',
            svg: './assets/benefits.png'
        },
        {
            title: 'Бесплатный Wi-Fi в вагоне',
            anchor: 'wifi',
            icon: 'fa-wifi',
            description: 'доступность для маломобильных групп',
            svg: './assets/invalid.png'
        },
        {
            title: 'Комфортабельные остановки',
            anchor: 'stops',
            icon: 'fa-wifi',
            description: 'система для слабовидящих пассажиров',
            svg: './assets/blind.png'
        },
        {
            title: 'Удобные способы оплаты',
            anchor: 'paymentways',
            icon: 'fa-wifi',
            description: 'создание дополнительных рабочих мест',
            svg: './assets/work.png'
        },
        {
            title: 'Бесшумные технологии',
            anchor: 'technology',
            icon: 'fa-wifi',
            description: 'безопасность работников на рабочем месте',
            svg: './assets/safety.png'
        },
        {
            title: 'Удобная маршрутная сеть',
            anchor: 'routenet',
            icon: 'fa-wifi',
            description: 'достойная оплата труда',
            svg: './assets/salary.png'
        },
        {
            title: 'Приоритетный проезд',
            anchor: 'priority',
            icon: 'fa-wifi',
            description: 'социальный и медицинский пакеты',
            svg: './assets/medpackage.png'
        },
        {
            title: 'Приоритетный проезд',
            anchor: 'priority',
            icon: 'fa-wifi',
            description: 'повышение квалификации',
            svg: './assets/grow.png'
        },
        {
            title: 'Приоритетный проезд',
            anchor: 'priority',
            icon: 'fa-wifi',
            description: 'забота об окружающей среде',
            svg: './assets/eco.png'
        },
        {
            title: 'Приоритетный проезд',
            anchor: 'priority',
            icon: 'fa-wifi',
            description: 'эффективное взаимодействие с органами власти, бизнес сообществами и деловыми партнерами',
            svg: './assets/business.png'
        }
    ];
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/responsibility.component.ts